import { useRef, useState, useEffect, useContext } from 'react'

// components
import Svg from '../Svg/Svg'
import FilterOverlay from './FilterOverlay'

// context
import { FilterContext } from '../../context/FilterContext'

const Filter = (props) => {
  // state values
  const [openFilters, setOpenFilters] = useState(false)

  // html dom references
  const filterContainerRef = useRef()

  // filter context
  const FilterContextState = useContext(FilterContext)

  const triggerFilter = (e) => {
    setOpenFilters(!openFilters)
  }

  useEffect(() => {
    if(openFilters) {
      document.querySelector('body').style = `overflow: hidden`
    } else {
      document.querySelector('body').removeAttribute('style')
    }
  }, [openFilters])

  // Render initial type filters
  const FiltersInHead = props.filters.types.items.map((type, index) => {
    if (index <= 4) {
      return (
        <a className={`Filter-item`}
           data-category={props.filters.types.type} data-id={type.id} data-title={type.title}
           onClick={(e) => { FilterContextState.selectFilter(e.target.dataset) }}
           key={`Filter-item-${index}`}>{type.title}</a>
      )
    }
  })

  return (
    <div className={`Filter${openFilters ? ` is-open` : ``}`}>
      <div className={`Filter-inner`}>
        <button className={`Filter-trigger is-mobile`} onClick={(e) => triggerFilter(e)}>
          <span className={`Filter-triggerLabel`}>Filter Projects</span>
          <Svg id={`icon-chevron-left`} modifier={`Filter-triggerSvg`}/>
        </button>

        <div className={`Filter-head`}>

          {FiltersInHead}

          <button className={`Filter-trigger`} onClick={(e) => triggerFilter(e)}>
            <span className={`Filter-triggerLabel`}>All Types</span>
            <Svg id={`icon-chevron-left`} modifier={`Filter-triggerSvg`}/>
          </button>
        </div>

        {FilterContextState.selectedFilters.length ?
          <div className={`Filter-container`} ref={filterContainerRef}>
            {FilterContextState.selectedFilters.map((filter, index) => {
              return (
                <a className={`Filter-selection`} key={`Filter-selection-${index}`}
                   data-category={filter.category}
                   data-id={filter.id}
                   onClick={(e) => { FilterContextState.removeFilter({ id: filter.id }) }}
                ><span>{filter.title}</span><Svg
                  id={`icon-close`} modifier={`Filter-selectionSvg`}/></a>
              )
            })}
          </div>
          : ``}
      </div>
      <FilterOverlay filters={props.filters} closeOverlay={() => { setOpenFilters(!openFilters)}}/>
    </div>
  )
}

export default Filter
